import "./TaskStatus.scss";

function TaskStatus({
  updateStatus,
  selectedStatus,
  showClear = false,
  statusConfig = [],
}) {
  return (
    <div className="status-content">
      {statusConfig.map((statusItem) => (
        <div
          key={statusItem.label}
          className={`status ${selectedStatus === statusItem.label ? "selected" : ""}`}
          onClick={() => updateStatus(statusItem.label)}
          style={{
            backgroundColor: statusItem.color,
          }}
        >
          {statusItem.label}
        </div>
      ))}
      {showClear && (
        <>
          <hr className="separator" />
          <div className="clear-button" onClick={() => updateStatus(null)}>
            Clear
          </div>
        </>
      )}
    </div>
  );
}

export default TaskStatus;
